import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";

const CWOpenDrawer = () => {
  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;

  let openDrawerPayload = {
    cash_drawer: {
      action: "open",
    },
  };
  Axios.post(`${printerURL}printer`, openDrawerPayload, {
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
      console.debug("openDrawer success!");
    })
    .catch((response) => {
      console.debug("openDrawer failed!", response);
    });
};

export default CWOpenDrawer;
